import { CartCalculationRule, CartDomainContext } from '../cart.domain';

export class CartItemPriceCalculationRule implements CartCalculationRule {
	/**
	 * Calcular el precio de los items del carrito con cada metodo de pago.
	 * @param context CartDomainContext
	 * @returns CartDomainContext
	 */
	public calculate(context: CartDomainContext): CartDomainContext {
		const processCartItem = context.menuItems.map(cartItem => {
			const channelProducts = cartItem?.productosCanal || [];
			const [
				{
					precios: [{ precio, precioBase }],
				},
			] = channelProducts ?? [{ precios: [{ precio: 0n, precioBase: 0n }] }];

			return {
				...cartItem,
				precio,
				precioBase,
			};
		});

		return {
			...context,
			menuItems: processCartItem,
		};
	}
}
